export const CATEGORY_LOADING = "CATEGORY_LOADING";
export const GET_POPULAR_CATEGORY = "GET_POPULAR_CATEGORY";
export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";
export const GET_SECOND_LEVEL_CATEGORIES = "GET_SECOND_LEVEL_CATEGORIES";
export const GET_THIRD_LEVEL_CATEGORIES = "GET_THIRD_LEVEL_CATEGORIES";
export const GET_FOURTH_LEVEL_CATEGORIES = "GET_FOURTH_LEVEL_CATEGORIES";

export const REMOVE_CATEGORY_DATA = "REMOVE_CATEGORY_DATA";
